import { Box, Paragraph, Text } from '@zillow/constellation-10';
import MoveInCostsTypes from '@common/constants/MoveInCostsConstants';
import type { MoveInCostsItems } from '@renter-hub/models/Types';
import { centsToDollars } from '@common/paymentsUtils/currencyUtils';

interface Props {
  zgFee: number;
  totalAmount: number;
  items: Array<MoveInCostsItems>;
}

const MoveInCostsItemsDisplay = ({ zgFee, totalAmount, items }: Props) => {
  const showCardFee = zgFee !== 0;
  return (
    <Box
      css={{
        display: 'grid',
        gridTemplateColumns: '1fr auto',
        columnGap: 'default',
        rowGap: 'tight',
        alignItems: 'start',
      }}
    >
      {items.map((moveInCostItem, i) => (
        <Box key={`moveInCosts${i}`} css={{ display: 'contents' }}>
          <Box>
            <Paragraph textStyle="body-bold">
              {moveInCostItem.subType || MoveInCostsTypes[moveInCostItem.type]}
            </Paragraph>
            {moveInCostItem.notes && (
              <Paragraph color="text.subtle" textStyle="body-sm">
                {moveInCostItem.notes}
              </Paragraph>
            )}
          </Box>
          <Text css={{ textAlign: 'right' }}>{centsToDollars(moveInCostItem.amount)}</Text>
        </Box>
      ))}
      {showCardFee && (
        <>
          <Paragraph textStyle="body-bold" className="fs-exclude">
            Card fee
          </Paragraph>
          <Text css={{ textAlign: 'right' }} className="fs-exclude">
            {centsToDollars(zgFee)}
          </Text>
        </>
      )}
      <Paragraph textStyle="body-bold" className="fs-exclude">
        Total payment
      </Paragraph>
      <Text textStyle="body-bold" css={{ textAlign: 'right' }} className="fs-exclude">
        {centsToDollars(totalAmount)}
      </Text>
    </Box>
  );
};

export default MoveInCostsItemsDisplay;
